
var IEM_I18N = {
  cartTitle:        "Вашата количка",
  emptyHeading:     "Количката е празна",
  emptyBody:        "Все още нищо не е добавено.",
  browse:           "Разгледай слушалките",
  decreaseQty:      "Намали количество",
  increaseQty:      "Увеличи количество",
  removeItem:       "Премахни",
  subtotal:         "Междинна сума",
  shipping:         "Доставка",
  total:            "Общо",
  checkout:         "Към плащане",
  trust:            "Криптирано плащане · Дебитна\/Кредитна карта",
  freeShipUnlocked: "Отключихте безплатна доставка",
  freeShipRemaining:"До безплатна доставка остават {{ amount }}",
  adding:           "Добавяне…",
  addedToCart:      "{{ vendor }}: {{ title }} е добавен в количката",
  addedGeneric:     "Добавено в количката",
  inStock:          "В наличност",
  soldOut:          "Изчерпан"
};

/* IEMs.bg — Cart drawer + AJAX cart + toast */
(function () {
  'use strict';

  const FREE_SHIPPING_CENTS = 20000; // €200 in cents

  function fmt(cents) {
    return '€' + (cents / 100).toLocaleString('', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ── Toast ── */
  const toast = document.getElementById('iem-toast');
  let toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('.iem-toast__msg').textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-show'), 3000);
  }

  /* ── Drawer open/close ── */
  const drawer = document.getElementById('cart-drawer');
  const scrim  = document.getElementById('cart-scrim');
  const openBtns = document.querySelectorAll('[data-cart-open]');

  function openDrawer(cart) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderDrawer(cart);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(b => b.addEventListener('click', () => openDrawer()));
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.getElementById('cart-drawer-close')?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* ── Fetch & render cart ── */
  async function getCart() {
    const res = await fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' });
    return res.json();
  }

  function injectSectionHTML(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const newDrawer = tmp.querySelector('#cart-drawer');
    if (!newDrawer) return;
    const emptyState  = newDrawer.querySelector('#cart-empty-state');
    const filledState = newDrawer.querySelector('#cart-filled-state');
    drawer.querySelector('#cart-empty-state')?.replaceWith(emptyState ?? document.createElement('div'));
    drawer.querySelector('#cart-filled-state')?.replaceWith(filledState ?? document.createElement('div'));
  }

  function buildShipBar(totalCents) {
    const pct      = Math.min(100, Math.round((totalCents / FREE_SHIPPING_CENTS) * 100));
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - totalCents);
    const msg = remaining > 0
       ? IEM_I18N.freeShipRemaining.replace(/\{\{\s*amount\s*\}\}/g, fmt(remaining))
       : IEM_I18N.freeShipUnlocked;
    const shipEl = drawer.querySelector('.cart-drawer__ship span:first-of-type');
    if (shipEl) shipEl.innerHTML = msg;
    const bar = drawer.querySelector('.cart-drawer__bar i');
    if (bar) bar.style.width = pct + '%';
  }

  function buildLines(items) {
    const body = drawer.querySelector('.cart-drawer__body');
    if (!body) return;
    if (items.length === 0) {
      body.innerHTML = '';
      return;
    }
    body.innerHTML = items.map(item => `
      <div class="cart-line" data-line-key="${item.key}">
        <div class="cart-line__media">
          ${item.image
            ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">`
            : ''}
        </div>
        <div>
          <div class="cart-line__brand">${item.vendor}</div>
          <div class="cart-line__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-line__brand" style="margin-top:3px">${item.variant_title}</div>`
            : ''}
          <div class="cart-line__qty">
            <button data-qty-change="-1" data-key="${item.key}" aria-label="${IEM_I18N.decreaseQty}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M5 12h14"/></svg>
            </button>
            <span>${item.quantity}</span>
            <button data-qty-change="1" data-key="${item.key}" aria-label="${IEM_I18N.increaseQty}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            </button>
          </div>
        </div>
        <div class="cart-line__right">
          <button class="cart-line__remove" data-remove="${item.key}" aria-label="${IEM_I18N.removeItem}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </button>
          <span class="iem-price iem-price--sm"><span class="iem-price__amount"><em>€</em>${(item.final_line_price / 100).toLocaleString('', { minimumFractionDigits: 0 })}</span></span>
        </div>
      </div>`).join('');
  }

  /* The shipping row is a static "calculated at checkout" notice rendered by
     Liquid — real rates only exist at checkout — so the total is the subtotal. */
  function buildFooter(cart) {
    const subtotalEl = drawer.querySelector('[data-subtotal]');
    const totalAmtEl = drawer.querySelector('[data-total] .iem-price__amount');
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
    if (totalAmtEl) {
      totalAmtEl.innerHTML = '<em>€</em>' +
        (cart.total_price / 100).toLocaleString('', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  async function renderDrawer(cart) {
    if (!cart) cart = await getCart();
    updateHeaderCount(cart.item_count);
    const emptyState  = drawer.querySelector('#cart-empty-state');
    const filledState = drawer.querySelector('#cart-filled-state');
    if (cart.item_count === 0) {
      if (emptyState)  emptyState.style.display = '';
      if (filledState) filledState.style.display = 'none';
      return;
    }
    if (emptyState)  emptyState.style.display = 'none';
    if (filledState) filledState.style.display = 'flex';
    buildShipBar(cart.total_price);
    buildLines(cart.items);
    buildFooter(cart);
  }

  /* ── Cart mutations ── */
  async function changeQty(key, delta) {
    const cart = await getCart();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    const newQty = Math.max(0, item.quantity + delta);
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty }),
    });
    renderDrawer(await res.json());
  }

  async function removeItem(key) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    renderDrawer(await res.json());
  }

  drawer?.addEventListener('click', e => {
    const qtyBtn    = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-remove]');
    if (qtyBtn)    changeQty(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qtyChange, 10));
    if (removeBtn) removeItem(removeBtn.dataset.remove);
  });

  /* ── Add to cart ── */
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = IEM_I18N.adding; }
      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-drawer'] }),
        });

        const addData = await addRes.json();
        
        const title = form.dataset.productTitle || addData.product_title || addData.title;
        const vendor = form.dataset.productVendor || addData.vendor || '';

        let successMessage = IEM_I18N.addedToCart;

        if (!vendor) {
          // This regex removes ": " regardless of spacing
          successMessage = successMessage.replace(/\{\{\s*vendor\s*\}\}:\s*/g, '');
        }

        showToast(title
          ? successMessage
              .replace(/\{\{\s*title\s*\}\}/g, title)
              .replace(/\{\{\s*vendor\s*\}\}/g, vendor)
          : IEM_I18N.addedGeneric);

        if (addData.sections?.['cart-drawer']) {
          injectSectionHTML(addData.sections['cart-drawer']);
          drawer.classList.add('is-open');
          if (scrim) scrim.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          const cart = await getCart();
          updateHeaderCount(cart.item_count);
        } else {
          const cart = await getCart();
          openDrawer(cart);
        }
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || IEM_I18N.addToCart; }
      }
    });
  });

  /* ── Store original button text before any mutation ── */
  document.querySelectorAll('[data-add-to-cart] [type="submit"]').forEach(btn => {
    btn.dataset.originalText = btn.textContent.trim();
  });

  /* ── Variant selector: update price & availability ── */
  document.querySelectorAll('[data-variant-selector]').forEach(sel => {
    sel.addEventListener('change', () => {
      const variantId  = sel.value;
      const variantData = JSON.parse(document.getElementById('product-variants-json')?.textContent || '[]');
      const variant    = variantData.find(v => String(v.id) === String(variantId));
      if (!variant) return;

      const priceEl = document.querySelector('[data-variant-price]');
      if (priceEl) priceEl.textContent = '€' + (variant.price / 100).toLocaleString('');

      const stockEl = document.querySelector('[data-stock-badge]');
      if (stockEl) {
        if (variant.available) {
          stockEl.className = 'iem-badge iem-badge--success';
          stockEl.innerHTML = `<span class="iem-badge__dot"></span>${IEM_I18N.inStock}`;
        } else {
          stockEl.className = 'iem-badge iem-badge--danger';
          stockEl.innerHTML = `<span class="iem-badge__dot"></span>${IEM_I18N.soldOut}`;
        }
      }

      const addBtn  = document.querySelector('[data-add-to-cart] [type="submit"]');
      if (addBtn)   addBtn.disabled = !variant.available;
      const idInput = document.querySelector('[data-add-to-cart] [name="id"]');
      if (idInput)  idInput.value = variantId;
    });
  });

  /* ── Gallery thumbnail switcher ── */
  document.querySelectorAll('.pdp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.pdp-gallery');
      gallery?.querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      if (src) {
        const main = gallery?.querySelector('.pdp-gallery__img');
        if (main) main.src = src;
      }
    });
  });

  /* ── Mobile nav ── */
  const mobScrim  = document.getElementById('mobnav-scrim');
  const mobNav    = document.getElementById('mobnav');
  const mobToggle = document.querySelector('[data-mobnav-toggle]');
  const mobClose  = document.getElementById('mobnav-close');

  function openMobNav()  { mobNav?.classList.add('is-open'); mobScrim?.classList.add('is-open'); }
  function closeMobNav() { mobNav?.classList.remove('is-open'); mobScrim?.classList.remove('is-open'); }

  mobToggle?.addEventListener('click', openMobNav);
  mobClose?.addEventListener('click', closeMobNav);
  mobScrim?.addEventListener('click', closeMobNav);

  /* ── Init ── */
  getCart().then(cart => {
    updateHeaderCount(cart.item_count);
    const emptyState  = drawer?.querySelector('#cart-empty-state');
    const filledState = drawer?.querySelector('#cart-filled-state');
    if (!emptyState || !filledState) return;
    if (cart.item_count === 0) {
      emptyState.style.display  = '';
      filledState.style.display = 'none';
    } else {
      emptyState.style.display  = 'none';
      filledState.style.display = 'flex';

    }
  });

})();
